import { makeStyles } from 'makeStyles';
import { MAIN, MAIN_ACTIVE, TEXT_MAIN } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  titleTypography: {
    fontSize: 20,
    marginBottom: 0,
    paddingLeft: 10,
  },
  headerPaper: {
    marginBottom: 20,
    padding: '25px 30px',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    overflow: 'hidden',
  },
  headerPaperGridTwo: {
    // marginTop: 15
  },
  headerGreyText: {
    color: theme.palette.grey[100],
  },
  headerNormalText: {
    fontSize: 15,
    fontWeight: 500,
  },
  tabsContainer: {
    gap: 20,
  },
  tabsRoot: {
    textTransform: 'none',
    minWidth: 150,
  },
  tabs: {
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
    '& div': {
      justifyContent: 'space-between',
    },
  },
  contentPanel: {
    marginTop: 20,
  },
  generateDrawHeading: {
    textAlign: 'center',
    marginTop: 10,
  },
  generateDrawMiddleText: {
    marginBottom: 10,
    marginTop: 10,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '60%',
    },
  },
  generateDrawButton: {
    marginTop: 10,
    minWidth: 120,
  },
  goBackTypography: {
    fontWeight: 600,
    fontSize: 15,
    marginBottom: 20,
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
      color: MAIN_ACTIVE,
      textDecoration: 'underline',
      '& svg > path': {
        stroke: `${MAIN_ACTIVE}!important`,
      },
    },
  },
  arrowGoBack: {
    height: '12px!important',
    '& > path': {
      stroke: MAIN,
    },
  },
  drawStatusWrapper: {
    marginTop: 3,
  },
  ratingsContainer: {
    width: 'auto',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 6,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      width: '100%',
    },
  },
  ratingItem: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  pipe: {
    width: 1,
    height: 20,
    margin: '0 15px 0 15px',
    backgroundColor: '#dadce0',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  icon: {
    marginLeft: 5,
  },
  linkButtonRoot: {
    color: '#427fc0',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'normal',
    textDecoration: 'underline',
    textAlign: 'left',
    fontSize: 14,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  label: {
    margin: '1px 5px 1px 0',
    fontSize: 13,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: TEXT_MAIN,
  },
  loading: {
    display: 'flex',
    margin: 'auto',
  },
  subtitle: {
    display: 'flex',
  },
  bold: {
    fontWeight: 'bold',
  },
  eventsSelector: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  chooseEvent: {
    '& h2': {
      lineHeight: 1.3,
    },
    '&:hover': {
      textDecoration: 'underline',
      '& $chooseEventIcon': {
        backgroundColor: theme.palette.grey[200],
      },
    },
  },
  chooseEventActive: {
    '& $chooseEventIcon': {
      transform: 'scaleY(-1)',
    },
  },
  chooseEventIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: theme.spacing(0.5),
    borderRadius: 4,
    color: TEXT_MAIN,
    width: 26,
    height: 26,
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
}));
